// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2H2FE","footer":"Form_footer__3qtpL"};